export default "__VITE_ASSET__284818b0__"